import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CART_RECOMMENDATION_CARDS_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { CartRecommendationCardsBlockScenarioContent } from '@front-platform/content-builder';

import {
  CART_RECOMMENDATION_CARDS_BLOCK_EMPTY_VM,
  CartRecommendationCardsBlockDataSource,
  CartRecommendationCardsBlockViewModel,
} from './cart-recommendation-cards-block-view-model';

export function toCartRecommendationCardsPreviewViewModel(
  content: CartRecommendationCardsBlockScenarioContent,
): CartRecommendationCardsBlockViewModel {
  return {
    recommendations: content.recommendations.map(product => ({
      type: 'product',
      data: product,
    })),
  };
}

@Injectable()
export class CartRecommendationCardsBlockPreviewDataSource implements CartRecommendationCardsBlockDataSource {
  readonly vm$: Observable<CartRecommendationCardsBlockViewModel> = previewScenarioForBloc$(
    CART_RECOMMENDATION_CARDS_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return CART_RECOMMENDATION_CARDS_BLOCK_EMPTY_VM;
      }
      const content = previewScenarioData<CartRecommendationCardsBlockScenarioContent>(
        scenario,
        CART_RECOMMENDATION_CARDS_BLOCK_COMPONENT,
      );
      return content
        ? toCartRecommendationCardsPreviewViewModel(content)
        : CART_RECOMMENDATION_CARDS_BLOCK_EMPTY_VM;
    }),
  );
}
